/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuranceEligibilityCheckReport
 */
export interface InsuranceEligibilityCheckReport {
    /**
     * 
     */
    status: InsuranceEligibilityCheckReportStatusEnum;
    /**
     * 
     */
    report_s3_key?: string;
    /**
     * 
     */
    report_access_url?: string;
}


/**
 * @export
 */
export const InsuranceEligibilityCheckReportStatusEnum = {
    Pending: 'pending',
    Generated: 'generated',
    Failed: 'failed',
} as const;
export type InsuranceEligibilityCheckReportStatusEnum = typeof InsuranceEligibilityCheckReportStatusEnum[keyof typeof InsuranceEligibilityCheckReportStatusEnum];


/**
 * Check if a given object implements the InsuranceEligibilityCheckReport interface.
 */
export function instanceOfInsuranceEligibilityCheckReport(value: object): value is InsuranceEligibilityCheckReport {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InsuranceEligibilityCheckReportFromJSON(json: any): InsuranceEligibilityCheckReport {
    return InsuranceEligibilityCheckReportFromJSONTyped(json, false);
}

export function InsuranceEligibilityCheckReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuranceEligibilityCheckReport {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'report_s3_key': json['report_s3_key'] == null ? undefined : json['report_s3_key'],
        'report_access_url': json['report_access_url'] == null ? undefined : json['report_access_url'],
    };
}

export function InsuranceEligibilityCheckReportToJSON(json: any): InsuranceEligibilityCheckReport {
    return InsuranceEligibilityCheckReportToJSONTyped(json, false);
}

export function InsuranceEligibilityCheckReportToJSONTyped(value?: InsuranceEligibilityCheckReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'report_s3_key': value['report_s3_key'],
        'report_access_url': value['report_access_url'],
    };
}

